require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-less-talk-more-action-hiring-practices-that-innovate-with-inclusion.json") })
        }
      }, "path---blog-less-talk-more-action-hiring-practices-that-innovate-with-inclusion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-less-talk-more-action-hiring-practices-that-innovate-with-inclusion!./.cache/json/blog-less-talk-more-action-hiring-practices-that-innovate-with-inclusion.json
// module id = 923
// module chunks = 231608221292675